// Kirin download origin (KIR-412): downloads.getkirin.com CDN, not S3.
// Agent lives under `kirin-agent` (not the legacy `kirin-claude` prefix).
const DOWNLOADS_BASE_URL = 'https://downloads.getkirin.com';
export const AGENT_BASE_URL = `${DOWNLOADS_BASE_URL}/kirin-agent`;
export const VSCODE_COPILOT_BASE_URL = `${DOWNLOADS_BASE_URL}/kirin-vscode-copilot`;
export const CURSOR_BASE_URL = `${DOWNLOADS_BASE_URL}/releases`;

/**
 * KIR-412: the public S3 website host is the dangling-DNS surface this ticket
 * removes. Build-time `VSIX_DOWNLOAD_URL_*` overrides are configured out-of-band
 * (Cloudflare Pages / Railway), so a stale S3 value in any environment would
 * silently re-introduce it. Treat such an override as unset so the CDN wins;
 * legitimate overrides (e.g. a `releases/pr-N` prefix) still take effect.
 */
const LEGACY_S3_DOWNLOAD_HOST = 'kirin-releases.s3.amazonaws.com';

export const overrideUrlOrEmpty = (url: string | undefined): string =>
  url && !url.includes(LEGACY_S3_DOWNLOAD_HOST) ? url : '';
